import {ChangeDetectionStrategy, Component, HostBinding, input} from '@angular/core';
import {Divider} from "primeng/divider";
import {FooterComponent} from "../footer/footer.component";
import {TryReasonComponent} from "../../pages/landing-page/try-reason/try-reason.component";
import {SignupButtonComponent} from "../signup-button/signup-button.component";
import {initialSignupRoute} from "../../pages/signup/specific-signup.routes";

@Component({
  selector: 'homey-full-footer',
  imports: [
    Divider,
    FooterComponent,
    TryReasonComponent,
    SignupButtonComponent,
  ],
  templateUrl: './full-footer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FullFooterComponent {
  @HostBinding('class') class = 'flex flex-col';
  public readonly showLogin = input(false);
  public readonly defaultSignupRoute = input<string[]>(initialSignupRoute);
}
